const currencySymbols = { RUB: '₽' };

export function formatPrice(money) {
  if (!money?.amount) return '';
  const value = Math.round(parseFloat(money.amount));
  const symbol = currencySymbols[money.currency] || money.currency;
  return `${value.toLocaleString('ru-RU')} ${symbol}`;
}

export function parsePriceInput(value) {
  const num = parseInt(value.replace(/\D/g, ''), 10);
  return Number.isNaN(num) ? undefined : num;
}
